import { GET_DASHBOARD_CONFIG } from 'const';
import { IActionFn } from 'interfaces';

export const getDashboardConfigAction: IActionFn<null> = () => ({
  type: GET_DASHBOARD_CONFIG.PENDING,
  payload: null,
});
